/** Remove undefined values recursively so Firestore setDoc never receives them. */
export function stripUndefined<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map((v) =>
      v && typeof v === 'object' ? stripUndefined(v as object) : v,
    ) as unknown as T
  }
  if (value && typeof value === 'object') {
    const result: Record<string, unknown> = {}
    for (const [key, v] of Object.entries(value as Record<string, unknown>)) {
      if (v === undefined) continue
      if (Array.isArray(v) || (v && typeof v === 'object')) {
        result[key] = stripUndefined(v as object)
      } else {
        result[key] = v
      }
    }
    return result as T
  }
  return value
}
